import script from "./songclass.vue?vue&type=script&setup=true&lang=js"
export * from "./songclass.vue?vue&type=script&setup=true&lang=js"

import "./songclass.vue?vue&type=style&index=0&id=dccbe944&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dccbe944"]])

export default __exports__